import axios from "axios";
import AuthService from "../api/login/auth.service";
import {
  BASE_API,
  BASE_API_CUST_PRIVILEGE_URL,
  BASE_API_POS,
  BASE_API_URL,
  BASE_API_URL3,
  BASE_API_WEB_NEW,
} from "../config";

const createApiInstance = (baseURL: string) => {
  const api = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      "Access-Control-Allow-Origin": "*",
    },
  });

  api.interceptors.request.use(async (request) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      request.headers.Authorization = `Bearer ${token.replace(/^"|"$/g, "")}`;
    }
    return request;
  });

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Xử lý lỗi mạng hoặc lỗi từ server ở đây
      console.error("API request failed:", error);

      if (error?.response?.status == 401) {
        //loi 401 thi call lại api refresh tại đây
        const originalRequest = error?.config;
        if (error?.response?.status == 401 && localStorage.getItem("token")) {
          const userName = localStorage.getItem("userName") || "{}";
          const refreshToken = localStorage.getItem("refreshToken") || "{}";
          const id = localStorage.getItem("id") || "{}";
          const dataRefresh = await AuthService.refreshToken({
            userName: userName,
            refreshToken: refreshToken,
            id: id,
          });
          console.log("dataRefresh", dataRefresh);
          originalRequest.headers.Authorization = `Bearer ${dataRefresh?.data?.jwt}`;
          return axios(originalRequest);
        }
      }
      return Promise.reject(error);
    }
  );
  return api;
};

const api = createApiInstance(BASE_API_URL || "");
const apiCust = createApiInstance(BASE_API_CUST_PRIVILEGE_URL || "");
const api3 = createApiInstance(BASE_API_URL3 || "");
const api4 = createApiInstance(BASE_API || "");
const apiPOS = createApiInstance(BASE_API_POS || "");
const apiWebNew = createApiInstance(BASE_API_WEB_NEW || "");

export { api, api3, apiCust, api4, apiPOS, apiWebNew };
